import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../services/authService';

const Sidebar = ({ user }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isSuperAdmin = user && user.role === 'super_admin';
  const isSchoolAdmin = user && user.role === 'admin';
  const isReferee = user && user.role === 'referee';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <Link to="/" className="brand-link">
        <img 
          src="https://person.ssk3.go.th/wp-content/uploads/2023/12/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B9%80%E0%B8%82%E0%B8%95-3-removebg-preview.png" 
          alt="SSK3 Logo" 
          className="brand-image img-circle elevation-3" 
          style={{ opacity: '.8' }}
        />
        <span className="brand-text font-weight-light">ระบบ SSK3 ITA</span>
      </Link>

      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <i className="fas fa-user-circle fa-2x text-light mt-1"></i>
          </div>
          <div className="info">
            <Link to="/profile" className="d-block">{user ? user.name : 'ผู้ใช้งาน'}</Link>
          </div>
        </div>

        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
            {/* Super Admin Menu */}
            {isSuperAdmin && (
              <>
                <li className="nav-item">
                  <Link to="/super-admin/dashboard" className={`nav-link ${location.pathname === '/super-admin/dashboard' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>หน้าหลัก</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/super-admin/users" className={`nav-link ${location.pathname === '/super-admin/users' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-users"></i>
                    <p>จัดการผู้ใช้งาน</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/super-admin/schools" className={`nav-link ${location.pathname === '/super-admin/schools' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-school"></i>
                    <p>จัดการโรงเรียน</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/super-admin/fiscal-years" className={`nav-link ${location.pathname === '/super-admin/fiscal-years' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-calendar-alt"></i>
                    <p>จัดการปีงบประมาณ</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/super-admin/system-settings" className={`nav-link ${location.pathname === '/super-admin/system-settings' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-cogs"></i>
                    <p>ตั้งค่าระบบ</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/super-admin/questionnaires" className={`nav-link ${location.pathname === '/super-admin/questionnaires' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-clipboard-list"></i>
                    <p>จัดการแบบสอบถาม</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/super-admin/referee-assignments" className={`nav-link ${location.pathname === '/super-admin/referee-assignments' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-user-check"></i>
                    <p>จัดการกรรมการประเมิน</p>
                  </Link>
                </li>
                 {/* เพิ่มเมนูรายงานสรุปที่นี่ */}
    <li className="nav-item">
      <Link to="/super-admin/response-summary" className={`nav-link ${location.pathname === '/super-admin/response-summary' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-clipboard-check"></i>
        <p>รายงานสรุปผู้ตอบแบบสอบถาม</p>
      </Link>
    </li>

    {/* เพิ่มเมนูรีเซ็ตคะแนน */}
    <li className="nav-item">
      <Link to="/super-admin/reset-scores" className={`nav-link ${location.pathname === '/super-admin/reset-scores' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-edit "></i>
        <p>ตรวจสอบคะแนน</p>
      </Link>
    </li>

     <li className="nav-item">
      <Link to="/super-admin/detailed-reports" className={`nav-link ${location.pathname === '/super-admin/detailed-reports' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-list-alt"></i>
        <p>สรุปคะแนนรายข้อ</p>
      </Link>
    </li>


 <li className="nav-item">
      <Link to="/super-admin/score-summary" className={`nav-link ${location.pathname === '/super-admin/score-summary' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-calculator"></i>
        <p>รายงานประมวลผลคะแนน</p>
      </Link>
    </li>

                <li className="nav-item">
                  <Link to="/super-admin/reports" className={`nav-link ${location.pathname === '/super-admin/reports' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-chart-bar"></i>
                    <p>รายงานผลการประเมิน</p>
                  </Link>
                </li>
              </>
            )}

            {/* School Admin Menu */}
            {isSchoolAdmin && (
              <>
                <li className="nav-item">
                  <Link to="/admin/dashboard" className={`nav-link ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>หน้าหลัก</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/respondents" className={`nav-link ${location.pathname === '/admin/respondents' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-users"></i>
                    <p>จัดการผู้ตอบแบบสอบถาม</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/oit" className={`nav-link ${location.pathname === '/admin/oit' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-link"></i>
                    <p>จัดการข้อมูล OIT</p>
                  </Link>
                </li>
              </>
            )}

            {/* Referee Menu */}
            {isReferee && (
              <>
                <li className="nav-item">
                  <Link to="/referee/dashboard" className={`nav-link ${location.pathname === '/referee/dashboard' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>หน้าหลัก</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/referee/evaluate-oit" className={`nav-link ${location.pathname === '/referee/evaluate-oit' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-check-square"></i>
                    <p>ประเมิน OIT</p>
                  </Link>
                </li>
              </>
            )}

            <li className="nav-item">
              <Link to="/profile" className={`nav-link ${location.pathname === '/profile' ? 'active' : ''}`}>
                <i className="nav-icon fas fa-user-cog"></i>
                <p>จัดการข้อมูลส่วนตัว</p>
              </Link>
            </li>


{/* เพิ่มเมนูออกจากระบบ */}
<li className="nav-item">
              <a className="nav-link cursor-pointer" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                <i className="nav-icon fas fa-sign-out-alt text-danger"></i>
                <p className="text-danger">ออกจากระบบ</p>
              </a>
            </li>

          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;